













































































































































































































































































































import Component from 'vue-class-component';
import FeedbackComponent from '@/components/base/FeedbackComponent';
import MockData from '@/globals/mock';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Utils } from '@/globals/Utils';
import { Inject } from 'vue-property-decorator';
import { FORM101_DATA, FORM101_META_DATA, FORM_READ_ONLY_MODE, SET_FORM101_DATA } from '@/types/form.types';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import {
  DELETE_DOCUMENT,
  DOCUMENTS, DOCUMENTS_ERRORS,
  DOWNLOAD_DOCUMENT,
  GET_DOCUMENT_LIST,
  SET_DOCUMENTS,
  UPLOAD_CLICKED,
  UPLOAD_DOCUMENT,
} from '@/types/documents.types';
import { Document, Documents } from '@/models/form/Documents.model';
import { InputFile } from '@/models/InputFile.model';
import { Form101MetaData } from '@/models/form/Form101MetaData.model';
import { GET_MANAGER_DOCUMENT_CONTENT, MANAGER_MODE } from '@/types/managerForm.types';
import { UPLOAD_FILE_ENABLE } from '@/types/lobby.types';

@Component({})
export default class IncomeDetailsStep extends FeedbackComponent {

  @Inject() public $validator: any;

  @Action(UPLOAD_DOCUMENT, StoreNamespace.DOCUMENT) public uploadDocument;
  @Action(UPLOAD_CLICKED, StoreNamespace.DOCUMENT) public uploadClicked;
  @Action(DELETE_DOCUMENT, StoreNamespace.DOCUMENT) public deleteDocument;
  @Action(DOWNLOAD_DOCUMENT, StoreNamespace.DOCUMENT) public downloadDocument;
  @Action(GET_MANAGER_DOCUMENT_CONTENT, StoreNamespace.MANAGER) public managerDownloadDocument;
  @Action(GET_DOCUMENT_LIST, StoreNamespace.DOCUMENT) public getDocumentList;

  @Mutation(SET_FORM101_DATA, StoreNamespace.FORM) public setForm101Data;
  @Mutation(SET_DOCUMENTS, StoreNamespace.DOCUMENT) public setDocuments;

  @Getter(FORM_READ_ONLY_MODE, StoreNamespace.FORM) public formReadOnlyMode!: boolean;
  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;
  @Getter(FORM101_META_DATA, StoreNamespace.FORM) public form101MetaData!: Form101MetaData;
  @Getter(DOCUMENTS, StoreNamespace.DOCUMENT) public documents!: Documents;
  @Getter(DOCUMENTS_ERRORS, StoreNamespace.DOCUMENT) public documentsErrors!: string[];
  @Getter(MANAGER_MODE, StoreNamespace.MANAGER) public managerMode!: boolean;
  @Getter(UPLOAD_FILE_ENABLE, StoreNamespace.AUTHENTICATION) public uploadFileEnable!: boolean;

  public upload500FileModal = false;
  public mockData: any = {};
  public workBeginDate: any = null;
  public retirementDate: any = null;
  public relativesAllowanceSum = 0;

  public created() {
    if (!this.form101Data.pensioner) {
      if (this.form101Data.workBeginDate == null ||
          new Date(Utils.stringToDate('' + this.form101Data.workBeginDate)).getFullYear() <
          this.form101Data.taxYear) {
        this.updateDate(new Date(this.form101Data.taxYear, 0, 1, 0, 0, 0, 0), 'workBeginDate');
        this.workBeginDate = Utils.stringToDate('' + this.form101Data.workBeginDate);
      } else if (this.form101Data.workBeginDate) {
        this.workBeginDate = Utils.stringToDate('' + this.form101Data.workBeginDate);
      }
    }
    if (this.form101Data.pensioner && this.form101Data.retirementDate) {
      this.retirementDate = Utils.stringToDate('' + this.form101Data.retirementDate);
    }
    if (!this.form101Data.extra1 && !this.form101Data.extra2) {
      this.updateForm101Data(null, 'extra1');
      this.updateForm101Data(null, 'extra2');
    }
    this.mockData = MockData.form101;
    this.$validator.localize({
      he: {
        custom: {
          // the field name
          extraMonthSalary: {
            // the rules
            required: this.$t('invalidExtraMonthSalaryCBErrorMessage'),
          },
        },
      },
    });
    this.relativesAllowanceSum = this.form101Data.taxYear > new Date().getFullYear() ?
        this.form101MetaData.relativesAllowanceNextYear : this.form101MetaData.relativesAllowanceCurrentYear;
  }

  public updateDate(date: Date, property: string) {
    this.updateForm101Data(date ? Utils.dateToString(date) : date, property);
  }

  public updateIncomeTypeCheckboxes(dataModel: Form101DataModel) {
    this.updateForm101Data(dataModel.annuity, 'annuity');
    this.updateForm101Data(dataModel.scholarship, 'scholarship');
  }

  public updateAsDetailedCheckboxes(dataModel: Form101DataModel) {
    this.updateForm101Data(dataModel.extraMonthSalary, 'extraMonthSalary');
    this.updateForm101Data(dataModel.extraAdditionalSalary, 'extraAdditionalSalary');
    this.updateForm101Data(dataModel.extraPartialSalary, 'extraPartialSalary');
    this.updateForm101Data(dataModel.extraDailySalary, 'extraDailySalary');
    this.updateForm101Data(dataModel.extraAnnuity, 'extraAnnuity');
    this.updateForm101Data(dataModel.extraScholar, 'extraScholar');
    this.updateForm101Data(dataModel.extraRelativesAllowance, 'extraRelativesAllowance');
    this.updateForm101Data(dataModel.extraBusiness, 'extraBusiness');
    this.updateForm101Data(dataModel.extraUnemployment, 'extraUnemployment');
    this.updateForm101Data(dataModel.extraRent, 'extraRent');
  }

  public updateCreditAndTaxCheckboxes(dataModel: Form101DataModel) {
    this.updateForm101Data(dataModel.extra3, 'extra3');
    this.updateForm101Data(dataModel.extra4, 'extra4');
  }

  public updateForm101Data(newVal: any, property: string) {
    if (property === 'extraIncome') {
      if (!newVal) {
        this.documents.extraIncomeFiles.forEach((file: Document) => {
          this.onRemovedClicked(file);
        });
        this.updateForm101Data(null, 'extra1');
        this.updateForm101Data(null, 'extra2');
        this.updateForm101Data(null, 'extra3');
        this.updateForm101Data(null, 'extra4');
        this.updateForm101Data(null, 'extraMonthSalary');
        this.updateForm101Data(null, 'extraAdditionalSalary');
        this.updateForm101Data(null, 'extraPartialSalary');
        this.updateForm101Data(null, 'extraDailySalary');
        this.updateForm101Data(null, 'extraAnnuity');
        this.updateForm101Data(null, 'extraScholar');
        this.updateForm101Data(null, 'extraRelativesAllowance');
        this.updateForm101Data(null, 'extraBusiness');
        this.updateForm101Data(null, 'extraUnemployment');
        this.updateForm101Data(null, 'extraRent');
      }
    }
    this.setForm101Data({ ...this.form101Data, [property]: newVal });
  }

  public onExtraRBClicked(newVal) {
    this.updateForm101Data(!!newVal, 'extra1');
    this.updateForm101Data(!newVal, 'extra2');
  }

  public open500FileDialog() {
    this.upload500FileModal = true;
  }

  public close500FileDialog() {
    this.upload500FileModal = false;
  }

  public openDeleteDialog(index: number, files: any[]) {
    if (files[index].docId) {
      this.$root.$emit('openDeleteFileDialog', files[index]);
    }
  }

  public onUploadClicked(inputFile: InputFile, docType: number) {
    this.uploadClicked({
      requestBody: {
        inputFile,
        docType,
        formId: this.form101Data.formId,
      },
    });
  }

  public onDownloadClicked(file: InputFile) {
    if (this.managerMode) {
      this.managerDownloadDocument({
        requestBody: {
          docId: file.docId,
          docName: file.docName,
          mimeType: file.type,
          officeNum: this.form101Data.officeNum,
          idNum: this.form101Data.idNum,
          positionNum: this.form101Data.positionNum,
        },
      });
    } else {
      this.downloadDocument({
        requestBody: {
          docId: file.docId,
          docName: file.docName,
          mimeType: file.type,
        },
      });
    }
  }

  public onRemovedClicked(file: Document) {
    this.deleteDocument(file.docId);
  }

}
